import { thingsToKeepInMind } from '../../../../../img/images';
import { ILocalization } from '../../../../../localization/definitions/types';
import { InstructionTickIcon } from '../../../../shared/icons/icons';

export const PleaseRememberSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='please-remember-slide'>
                <img alt='' src={thingsToKeepInMind} />
            </div>
        </div>
    );
};

export const PleaseRememberSlideImageSrc = thingsToKeepInMind;

interface Props {
    localization: ILocalization;
}

export const PleaseRememberSlideContent = ({ localization }: Props) => {
    const { pleaseRememberSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{pleaseRememberSlide.pleaseRemember}​</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {pleaseRememberSlide.timelineDatesAre}{' '}
                    <span className='instruction-content-bold'>
                        {pleaseRememberSlide.crucial}
                    </span>{' '}
                    {pleaseRememberSlide.forYour}{' '}
                    <span className='instruction-content-bold'>
                        {pleaseRememberSlide.success}
                    </span>
                    .​
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {pleaseRememberSlide.alwaysCheckYourNext}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {pleaseRememberSlide.consoultOurHelp}​​
                </div>
            </div>
        </div>
    );
};
